namespace $ {

	export class $shm_hitalama_map_history_storage_target_writer extends $giper_baza_entity.with({
		Count: $giper_baza_atom_real,
		Counter: $giper_baza_atom_dict,
		Pages: $giper_baza_list_link.to( ()=> $shm_hitalama_map_history_storage_page ),
		Refs: $giper_baza_atom_dict,
	}) {

		count( next?: number ) {
			this.keys()
			if( next === undefined ) return this.counter_state().count
			if( !Number.isSafeInteger( next ) || next < 0 ) throw new Error( 'Некорректный счётчик истории' )
			if( this.Counter() ) {
				const state = this.counter_state()
				this.Counter()!.val({ ...state, count: next })
			}
			let count = this.Count()
			if( !count && next !== undefined ) {
				this.Count( null )
				count = this.Count()
			}
			return count?.val( next ) ?? 0
		}

		counter_state(): { v: number, count: number, pending: readonly string[] } {
			this.keys()
			const atom = this.Counter()
			if( !atom ) {
				const count = this.Count()?.val() ?? 0
				if( !Number.isSafeInteger( count ) || count < 0 ) throw new Error( 'Повреждён счётчик истории' )
				return { v: 1, count, pending: [] }
			}
			const state = atom.val()
			if( !state || state.v !== 1 || typeof state.count !== 'number' || !Number.isSafeInteger( state.count ) || state.count < 0
				|| !Array.isArray( state.pending ) || state.pending.length > 64
				|| state.pending.some( link=> typeof link !== 'string' || !link )
				|| new Set( state.pending ).size !== state.pending.length
				|| $mol_charset_encode( JSON.stringify( state ) ).byteLength > 48000 ) {
				throw new Error( 'Повреждён счётчик истории' )
			}
			return state as { v: number, count: number, pending: readonly string[] }
		}

		counter_event( link: string ) {
			return this.$.$giper_baza_glob.Pawn( new $giper_baza_link( link ), $shm_hitalama_map_history_event )
		}

		/** Persist increment and its event receipt together, before acknowledging it. */
		@ $mol_action
		counter_begin( link: string ) {
			const state = this.counter_state()
			if( state.pending.includes( link ) ) return state.count
			if( state.pending.length >= 64 ) throw new Error( 'Слишком много незавершённых записей истории' )
			if( state.count >= Number.MAX_SAFE_INTEGER ) throw new Error( 'Переполнен счётчик истории' )
			const next = { v: 1, count: state.count + 1, pending: [...state.pending, link] }
			if( !link || $mol_charset_encode( JSON.stringify( next ) ).byteLength > 48000 ) {
				throw new Error( 'Подтверждения истории превышают допустимый размер' )
			}
			this.Counter( null )!.val( next )
			return next.count
		}

		@ $mol_action
		counter_ack( links: readonly string[] ) {
			const removed = new Set( links ), state = this.counter_state()
			const pending = state.pending.filter( link=> !removed.has( link ) )
			if( pending.length !== state.pending.length ) this.Counter()!.val({ ...state, pending })
		}

		@ $mol_action
		counter_flush( target: string ) {
			const pending = $mol_wire_sync( this ).counter_state().pending
			for( const link of pending ) $mol_wire_sync( this ).counter_event( link ).index_count_applied( target, true )
			this.counter_ack( pending )
		}

		@ $mol_action
		count_event_apply( event: $shm_hitalama_map_history_event, target: string ) {
			if( event.index_count_applied( target ) ) return this.count()
			// Finish previously persisted receipts before accepting another event.
			// This also recovers a stop between the increment and its acknowledgement.
			this.counter_flush( target )
			if( event.index_count_applied( target ) ) return this.count()
			this.counter_begin( event.link().str )
			event.index_count_applied( target, true )
			this.counter_ack([ event.link().str ])
			return this.count()
		}

		legacy_pages() {
			this.keys()
			return this.Pages()?.remote_list() ?? []
		}

		refs() {
			this.keys()
			const atom = this.Refs()
			if( !atom ) return null
			const value = atom.val()
			if( !value || value.v !== 1 || typeof value.tail !== 'string'
				|| typeof value.seed !== 'number' || !Number.isSafeInteger( value.seed )
				|| typeof value.count !== 'number' || !Number.isSafeInteger( value.count ) || value.count < 0
				|| Boolean( value.tail ) !== Boolean( value.count )
				|| (value.indexed !== undefined && typeof value.indexed !== 'boolean')
				|| (value.max_time !== undefined && value.max_time !== null
					&& (typeof value.max_time !== 'number' || !Number.isFinite(value.max_time))) ) {
				throw new Error( 'Повреждён указатель страниц истории' )
			}
			return value as { v: number, seed: number, tail: string, count: number, max_time?: number | null, indexed?: boolean }
		}

		position_slot( link: string, auto = false ) {
			const hash = $mol_hash_string(link) >>> 0
			let path = ''
			for( let depth = 6; depth < 128; ++depth ) {
				const land = this.land().area_make( $mol_hash_string(`${this.link().str}:history-ref-index:${hash % 64}:${path}`) )
				const index = land.Data($shm_hitalama_map_history_storage_target_writer_index)
				if( !auto ) index.ready()
				index.units()
				const positions = index.Positions()
				positions?.units()
				const existing = positions?.key(link)
				if( existing ) return existing
				if( !index.Routing()?.val() ) {
					if( !auto ) return null
					if( (positions?.keys().length ?? 0) < 32 ) return index.Positions(null)!.key(link,'auto')!
					this.position_route(index)
				}
				const block = Math.floor(depth / 32)
				const bits = block ? $mol_hash_string(`${link}:history-ref-route:${block}`) >>> 0 : hash
				path += String((bits >>> (depth % 32)) & 1)
			}
			throw new Error('Переполнен индекс ссылок истории')
		}

		@ $mol_action
		private position_route( index: $shm_hitalama_map_history_storage_target_writer_index ) {
			if( !index.Routing()?.val() ) index.Routing(null)!.val(true)
		}

		position_value( seed: number, index: number ) { return { seed, index } }

		@ $mol_action
		private position_write( link: string, seed: number, index: number ) {
			const value = $mol_wire_sync(this).position_value(seed,index)
			const slot = $mol_wire_sync(this).position_slot(link,true)!
			$mol_wire_sync(slot).val(value)
		}

		private position_read( link: string, refs: NonNullable<ReturnType<$shm_hitalama_map_history_storage_target_writer['refs']>> ) {
			const value = this.position_slot(link)?.val()
			if( !value ) return null
			if( !Number.isSafeInteger(value.seed) || !Number.isSafeInteger(value.index) || Number(value.index) < 0 ) {
				throw new Error('Повреждена позиция страницы истории')
			}
			return value.seed === refs.seed && Number(value.index) < refs.count ? Number(value.index) : null
		}

		chunk( seed: number, index: number ) {
			return this.land().area_make( $mol_hash_string( `${ this.link().str }:history-refs:${ seed }:${ index }` ) )
				.Data( $shm_hitalama_map_history_storage_target_writer_chunk )
		}

		refs_plan( pages: readonly $shm_hitalama_map_history_storage_page[] ) {
			const unique = [...new Map(pages.map(page=> [page.link().str,page])).values()]
			const links = unique.map(page=> page.link().str)
			let max_time = Number.MIN_SAFE_INTEGER
			const before = unique.map(page=> {
				const bound = max_time
				for( const summary of page.entries() ) max_time = Math.max(max_time,summary.t)
				return bound
			})
			const chunks: string[][] = []
			for( let index = 0; index < links.length; index += 64 ) chunks.push( links.slice( index, index + 64 ) )
			return { seed: $mol_hash_string( JSON.stringify( links ) ), count: links.length, chunks, before, max_time }
		}

		@ $mol_action
		pages( next?: readonly $shm_hitalama_map_history_storage_page[] ): readonly $shm_hitalama_map_history_storage_page[] {
			if( next === undefined ) return [...this.pages_reverse()].reverse()
			const plan = $mol_wire_sync( this ).refs_plan( next )
			let previous = ''
			for( let index = 0; index < plan.chunks.length; ++index ) {
				const chunk = this.chunk( plan.seed, index )
				chunk.packed({ v: 1, previous, items: plan.chunks[index], before: plan.before.slice(index*64,(index+1)*64) })
				previous = chunk.link().str
			}
			const indexed_count = plan.count ? plan.count - (plan.count % 64 || 64) : 0
			for( let index = 0; index < indexed_count; ++index ) this.position_write(plan.chunks[Math.floor(index/64)][index%64],plan.seed,index)
			this.Refs( null )!.val({ v: 1, seed: plan.seed, count: plan.count, tail: previous, max_time: plan.max_time, indexed: true })
			// Publish the new head first. Legacy readers remain supported, but no
			// growing reference list is maintained in the shared index land.
			this.Pages()?.items([])
			return next
		}

		append_plan( page: $shm_hitalama_map_history_storage_page, time?: number ) {
			if( time !== undefined && !Number.isSafeInteger(time) ) throw new Error( 'Некорректное время события истории' )
			const refs = this.refs()!
			const previous = refs.tail ? this.$.$giper_baza_glob.Pawn(
				new $giper_baza_link( refs.tail ), $shm_hitalama_map_history_storage_target_writer_chunk,
			).packed() : { v: 1, previous: '', items: [] as readonly string[], before: [] as readonly (number | null)[] }
			const link = page.link().str
			// Chunk content is written before the authoritative head. A stopped
			// append may have left an extra link there; it is not committed yet.
			const committed = previous.items.slice( 0, refs.count ? ( refs.count % 64 || 64 ) : 0 )
			const prior = refs.max_time ?? null
			const max_time = prior === null || time === undefined ? null : Math.max(prior,time)
			const before = committed.map((_,index)=> previous.before?.[index] ?? null)
			const position = committed.indexOf(link)
			if( position >= 0 ) {
				// A delayed event can update an earlier page in this block. Raise
				// every later prefix bound rather than assume timestamps increase.
				for( let index = position+1; index < before.length; ++index ) {
					// Legacy callers may not know the new event time. Keeping the old
					// finite prefix would allow a lazy reader to skip this changed page.
					if( time === undefined ) before[index] = null
					else if( before[index] !== null ) before[index] = Math.max(before[index]!,time)
				}
				return { chunk: this.$.$giper_baza_glob.Pawn(new $giper_baza_link(refs.tail),$shm_hitalama_map_history_storage_target_writer_chunk),
					packed: { ...previous, items: committed, before }, refs: { ...refs, max_time }, updates: [] }
			}
			const indexed = refs.indexed && refs.count > 64 ? this.position_read(link,refs) : null
			if( indexed !== null ) {
				const updates: { chunk: $shm_hitalama_map_history_storage_target_writer_chunk, packed: ReturnType<$shm_hitalama_map_history_storage_target_writer_chunk['packed']> }[] = []
				for( let block = Math.floor(indexed/64); block <= Math.floor((refs.count-1)/64); ++block ) {
					const chunk = this.chunk(refs.seed,block), packed = chunk.packed()
					if( block === Math.floor(indexed/64) && packed.items[indexed%64] !== link ) throw new Error('Позиция страницы не совпадает с цепочкой истории')
					const before = packed.items.map((_,item)=> {
						const bound = packed.before?.[item] ?? null
						return block*64+item <= indexed ? bound : time === undefined ? null : bound === null ? null : Math.max(bound,time)
					})
					updates.push({ chunk, packed: { ...packed, before } })
				}
				return { chunk: null, packed: null, refs: { ...refs, max_time }, updates }
			}
			const rollover = committed.length === 64
			const chunk = this.chunk( refs.seed, Math.floor( refs.count / 64 ) )
			return {
				chunk,
				packed: { v: 1, previous: rollover ? refs.tail : previous.previous,
					items: rollover ? [link] : [...committed, link], before: rollover ? [prior] : [...before,prior] },
				refs: { ...refs, tail: chunk.link().str, count: refs.count + 1, max_time },
				updates: [],
			}
		}

		@ $mol_action
		page_add( page: $shm_hitalama_map_history_storage_page, time?: number ) {
			if( !this.refs() ) this.pages( $mol_wire_sync( this ).legacy_pages() )
			// Upgrade old chains only on an explicit write, never while opening history.
			if( !this.refs()!.indexed ) this.pages( $mol_wire_sync(this).pages() )
			const plan = $mol_wire_sync( this ).append_plan( page, time )
			if( !plan ) return
			if( plan.chunk && plan.packed ) plan.chunk.packed( plan.packed )
			for( const update of plan.updates ) update.chunk.packed(update.packed)
			if( plan.refs.count > this.refs()!.count && this.refs()!.count > 0 && this.refs()!.count % 64 === 0 ) {
				const tail = $mol_wire_sync(this).tail_positions()
				for( const [index,link] of tail.links.entries() ) this.position_write(link,tail.seed,tail.offset+index)
			}
			this.Refs( null )!.val( plan.refs )
		}

		tail_positions() {
			const refs = this.refs()!
			const chunk = this.$.$giper_baza_glob.Pawn(new $giper_baza_link(refs.tail),$shm_hitalama_map_history_storage_target_writer_chunk)
			return { seed: refs.seed, offset: refs.count-64, links: chunk.packed().items.slice(0,64) }
		}

		* pages_reverse(): Generator< $shm_hitalama_map_history_storage_page > {
			for( const value of this.pages_bounded_reverse() ) yield value.page
		}

		* pages_bounded_reverse(): Generator< { page: $shm_hitalama_map_history_storage_page, bound: number } > {
			const refs = this.refs()
			if( !refs ) {
				for( const page of [...this.legacy_pages()].reverse() ) yield { page, bound: Number.POSITIVE_INFINITY }
				return
			}
			const visited = new Set<string>()
			let link = refs.tail, remaining = refs.count
			while( link ) {
				if( visited.has( link ) ) throw new Error( 'Циклические ссылки страниц истории' )
				visited.add( link )
				const packed = this.$.$giper_baza_glob.Pawn(
					new $giper_baza_link( link ), $shm_hitalama_map_history_storage_target_writer_chunk,
				).packed()
				const expected = link === refs.tail ? ( refs.count % 64 || 64 ) : Math.min( remaining, 64 )
				if( packed.items.length < expected ) throw new Error( 'Не загружены ссылки страниц истории' )
				for( let index = expected - 1; index >= 0; --index ) {
					if( --remaining < 0 ) throw new Error( 'Некорректное число страниц истории' )
					yield { page: this.$.$giper_baza_glob.Pawn( new $giper_baza_link( packed.items[index] ), $shm_hitalama_map_history_storage_page ),
						bound: packed.before?.[index] ?? Number.POSITIVE_INFINITY }
				}
				link = packed.previous
			}
			if( remaining !== 0 ) throw new Error( 'Не загружена цепочка страниц истории' )
		}

	}

}
